import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MakePaymentResponse } from '../../../pages/receive/model/makePaymentReq';


@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.css']
})
export class LinkComponent implements OnInit {
   
  paymentResponse = new MakePaymentResponse();
  constructor(public dialogRef: MatDialogRef<LinkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


  ngOnInit(){
    this.paymentResponse = this.data.response;
  }
 

}
